import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import getImages from 'utils/getImages';
import generateSizes from 'utils/generateSizes';
import Link from 'containers/atoms/LinkContainer';
import ResponsiveImage from 'components/atoms/ResponsiveImage';
import s from './FlexibleImageWithText.css';

const FlexibleImageWithText = ({ fields, children, renderer, darkMode }) => {
  if (!children) return null;

  const sizes = getImages('LANDSCAPE');
  const imageSizes = generateSizes({
    lg: '640px',
    md: 'calc(84vw - 24px)',
    sm: '96vw - 24px',
    default: 'calc(100vw - 48px)',
  });

  const image = children.find(({ type }) => type === 'simple_image');
  const [top, bottom] = children.filter(({ type }) => type === 'paragraph');

  return (
    <Link
      to={`#${fields.anchorName?.rawText}`}
      className={classNames(s.wrapper, darkMode ? s.light : s.dark)}
    >
      {image && (
        <ResponsiveImage
          className={classNames(s.image)}
          src={sizes.toSrc(image.relation.fields.BASE_LANDSCAPE.href_full, 'L')}
          srcSet={sizes.toSrcSet(image.relation.fields.BASE_LANDSCAPE.href_full)}
          sizes={imageSizes}
          alt={image.relation.fields.alttext}
        />
      )}
      {top && <span className={s.top}>{top.fields.paragraph.rawText}</span>}
      {bottom && renderer(bottom, darkMode)}
    </Link>
  );
};

export default withStyles(s)(FlexibleImageWithText);
